import { DateRangeSelector } from "@/components/stats/DateRangeSelector";
import { OverviewCards } from "@/components/stats/OverviewCards";
import { VolumeTrend } from "@/components/stats/VolumeTrend";
import PageTitleScript from "@/components/MetaScript";
import { useParams } from "react-router-dom";
import { useTrackedExercises } from "@/hooks/useTrackedExercises";
import { Link } from "react-router-dom";
import { ArrowLeft, PencilLineIcon } from "lucide-react";

export function StatsPerExercisePage() {
  // Use the useParams hook to get the route parameters
  const { exerciseNanoId } = useParams<{
    // both are required
    exerciseNanoId: string;
  }>();

  const { data: trackedExercises } = useTrackedExercises();
  const exercise = trackedExercises?.find(
    (exercise) => exercise.nano_id === exerciseNanoId
  );

  if (!exercise) {
    return <div>Exercise not found</div>;
  }

  return (
    <div className="flex flex-col">
      <PageTitleScript title={`${exercise.name} Stats`} />

      <div className="flex items-center justify-between px-6 mb-6">
        <div className="flex items-center">
          <Link to="/stats" className="mr-2">
            <ArrowLeft size={24} />
          </Link>
          <h1 className="text-base font-semibold text-tx-dark">
            {exercise.name} Stats
          </h1>
        </div>
        <Link
          to={`/settings/exercises/${exercise.nano_id}`}
          className="flex items-center text-gray-500 hover:text-primary transition-colors"
        >
          <PencilLineIcon size={18} />
        </Link>
      </div>

      {/* Date Range Selector */}
      <div className="px-6 mb-6">
        <DateRangeSelector />
      </div>

      {/* Overview Statistics */}
      <div className="px-6 mb-12">
        <OverviewCards exerciseNanoId={exerciseNanoId} />
      </div>

      <div className="px-6 mb-6">
        <VolumeTrend exerciseNanoId={exerciseNanoId} />
      </div>
    </div>
  );
}
